"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msFromNs = exports.executeAsyncAndMeasureDuration = exports.callAfterWaiting = exports.waitMilliseconds = exports.NANOSECONDS_PER_SECOND = exports.MILLISECONDS_PER_SECOND = exports.SECONDS_PER_MINUTE = exports.MINUTES_PER_HOUR = exports.HOURS_PER_DAY = void 0;
/**
 * @constant {number} Hours in 1 day.
 */
exports.HOURS_PER_DAY = 24;
/**
 * @constant {number} Minutes in 1 hour.
 */
exports.MINUTES_PER_HOUR = 60;
/**
 * @constant {number} Seconds in 1 minute.
 */
exports.SECONDS_PER_MINUTE = 60;
/**
 * @constant {number} Milliseconds in 1 second.
 */
exports.MILLISECONDS_PER_SECOND = 1000;
/**
 * @constant {number} Nanoseconds in 1 second.
 */
exports.NANOSECONDS_PER_SECOND = 1000000000;
/**
 * Waits a given number of milliseconds, then resolves
 *
 * @param {number} ms the milliseconds to wait for
 *
 * @returns {Promise<void>} a promise that always resolves after `ms` milliseconds
 */
const waitMilliseconds = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.waitMilliseconds = waitMilliseconds;
/**
 * @param  {number} ms the number of ms to wait
 * @param  {AsyncFunction<T, U>} fn the function to call after waiting
 * @param  {Parameters<AsyncFunction<T, U>>} args parameters to pass when invoking fn
 *
 * @returns {Promise<U>} return value of fn
 */
const callAfterWaiting = async (ms, fn, ...args) => {
    await (0, exports.waitMilliseconds)(ms);
    return fn(...args);
};
exports.callAfterWaiting = callAfterWaiting;
/**
 * @param  {AsyncFunction<T, U>} asyncFn the funtion to execute and measure
 * @param  {Parameters<AsyncFunction<T, U>>} args to pass to asyncFn upon invocation
 *
 * @returns {Promise<IFunctionResultAndExecutionDuration<U>>} object containing the result of asyncFn and the duration in nanoseconds.
 */
const executeAsyncAndMeasureDuration = async (asyncFn, ...args) => {
    const startTime = process.hrtime.bigint();
    const result = await asyncFn(...args);
    const endTime = process.hrtime.bigint();
    const duration = endTime - startTime;
    return {
        durationNs: duration,
        result,
    };
};
exports.executeAsyncAndMeasureDuration = executeAsyncAndMeasureDuration;
/**
 * Return the number of milliseconds from the provided number of nanoseconds.
 *
 * @param {bigint} value - nanoseconds
 *
 * @returns {number} - milliseconds
 */
function msFromNs(value) {
    return (Number(value) * exports.MILLISECONDS_PER_SECOND) / exports.NANOSECONDS_PER_SECOND;
}
exports.msFromNs = msFromNs;
//# sourceMappingURL=timers.js.map